import type { CheeseEventProperties } from '@/utils/cheeseTracking'

/** Product analytics events. docs/cheese-tracking.md describes when each one fires. */
export type CheeseEventName =
    // Account
    | 'signup_completed'
    | 'role_profile_visibility_changed'
    // Jobs: candidate
    | 'job_application_started'
    | 'job_application_submitted'
    | 'job_alert_subscribed'
    | 'job_alert_prompt_clicked'
    | 'job_comparison_opened'
    | 'job_cv_saved'
    | 'job_cv_reused'
    | 'talentbase_why_drafted'
    // Jobs: employer
    | 'job_created'
    | 'job_published'
    | 'job_credits_checkout_started'
    | 'applicant_stage_changed'
    | 'job_offer_sent'
    | 'talentbase_matches_viewed'
    | 'talentbase_match_clicked'
    // Chat
    | 'chat_panel_opened'
    | 'chat_conversation_opened'
    | 'chat_message_sent'
    | 'chat_message_send_failed'
    | 'chat_next_step_clicked'
    // Mentoring
    | 'mentoring_request_started'
    | 'mentoring_request_submitted'
    | 'mentoring_request_accepted'
    | 'mentoring_request_declined'
    | 'mentoring_started'
    | 'mentoring_finished'
    | 'top_mentoring_application_started'
    | 'top_mentoring_application_submitted'
    // Volunteering
    | 'volunteering_request_started'
    | 'volunteering_request_submitted'
    | 'volunteering_request_approved'
    | 'volunteering_request_declined'
    | 'volunteer_stage_changed'
    | 'project_created'
    | 'project_published'
    // Sebapoznanie
    | 'test_start_clicked'
    | 'test_started'
    | 'test_completed'
    | 'test_submit_failed'
    | 'test_next_step_clicked'
    // Blog
    | 'blog_next_step_clicked'
    // Education
    | 'education_interest_clicked'
    // Unavailable offer recovery
    | 'unavailable_offer_viewed'
    | 'unavailable_offer_recommendations_loaded'
    | 'unavailable_offer_recommendation_clicked'
    | 'unavailable_offer_browse_clicked'

/**
 * Optional, consent-gated analytics. Capture the app in setup, before async work.
 * Never throws: core composables call this, and analytics must not break them.
 */
export function useCheese() {
    const app = tryUseNuxtApp()
    const track = (name: CheeseEventName, properties: CheeseEventProperties = {}) => {
        if (import.meta.server) return
        const nuxtApp = app ?? tryUseNuxtApp()
        nuxtApp?.$cheeseTrack?.(name, properties)
    }
    return { track }
}
